module.exports = __webpack_public_path__ + "img/blank_logo.7bc0f440.png";